export default "__VITE_ASSET__DSbSBg2G__"